import { usePartnerId } from '@retailer-platform/dashboard/routing'
import { useDomainGoToPath } from './domain/routing'

export interface GoToAccountCreatePageProps {
  preselectRoleId?: string
}

export const useGotoAccountCreatePage = (props: GoToAccountCreatePageProps = {}) => {
  const partnerId = usePartnerId({ throwOnMissing: false })

  const createAccountRoute = partnerId
    ? 'partner-account-management-create'
    : 'app-admin-account-management-create'

  return useDomainGoToPath(createAccountRoute, {
    preselectRole: props.preselectRoleId,
  })
}
